export type EventLog = {
  id: string;
  actor: Actor;
  eventType: EventType;
  eventData: string;
  timestamp: string;
};

export type Actor = {
  id: string;
  name: string;
  email?: string;
};

// noinspection JSUnusedGlobalSymbols
export enum EventType {
  AcceptedCompanyTerms = "AcceptedCompanyTerms",
  AcceptedInvitationByAUser = "AcceptedInvitationByAUser",
  AcceptedUserTerms = "AcceptedUserTerms",
  AddToEnterpriseAccount = "AddToEnterpriseAccount",
  ApiCallEvent = "ApiCallEvent",
  BeneficialOwnersStatementSubmitted = "BeneficialOwnersStatementSubmitted",
  BRStatusUpdateEmail = "BRStatusUpdateEmail",
  CancelledSignatureRequestEvent = "CancelledSignatureRequestEvent",
  ChangedNominalValue = "ChangedNominalValue",
  ChangedTransactionDate = "ChangedTransactionDate",
  CompanyMovedToPortfolio = "CompanyMovedToPortfolio",
  CompanyRemovedFromPortfolio = "CompanyRemovedFromPortfolio",
  CreatedPortfolio = "CreatedPortfolio",
  CreatedUserApiKey = "CreatedUserApiKey",
  CustomRoleDelete = "CustomRoleDelete",
  CustomRoleInvite = "CustomRoleInvite",
  CustomRoleNew = "CustomRoleNew",
  CustomRoleRevoke = "CustomRoleRevoke",
  CustomRoleUpdate = "CustomRoleUpdate",
  DeletedAutoimport = "DeletedAutoimport",
  DeletedComment = "DeletedComment",
  DeletedLastTransactionLog = "DeletedLastTransactionLog",
  DeletedShareholderRegister = "DeletedShareholderRegister",
  DeletedTransactionLog = "DeletedTransactionLog",
  DeregisteredCompany = "DeregisteredCompany",
  DuplicatedProject = "DuplicatedProject",
  GeneralMeetingStatusUpdate = "GeneralMeetingStatusUpdate",
  GivenAdminAccessToUser = "GivenAdminAccessToUser",
  GrantedAdminAccess = "GrantedAdminAccess",
  MigratedBoardMeetingsFoldersToRootFolder = "MigratedBoardMeetingsFoldersToRootFolder",
  MigratedProject = "MigratedProject",
  MigratePriceEvent = "MigratePriceEvent",
  ModifiedPermissions = "ModifiedPermissions",
  NotifiedShareholders = "NotifiedShareholders",
  OrderLiveGeneralMeeting = "OrderLiveGeneralMeeting",
  PortfolioDeleted = "PortfolioDeleted",
  PortfolioUpdated = "PortfolioUpdated",
  RegisteredShareholderCommitment = "RegisteredShareholderCommitment",
  ReplayedTransactions = "ReplayedTransactions",
  RerunSealing = "RerunSealing",
  ResendDocumentForSigning = "ResendDocumentForSigning",
  RevokedAdminAccess = "RevokedAdminAccess",
  RoleMappingAdded = "RoleMappingAdded",
  RoleMappingRemoved = "RoleMappingRemoved",
  SearchedBeneficialOwners = "SearchedBeneficialOwners",
  SentMeetingEmail = "SentMeetingEmail",
  SentMessageFromMessaging = "SentMessageFromMessaging",
  SentNoticeOfBoardMeeting = "SentNoticeOfBoardMeeting",
  SentNoticeOfGeneralMeeting = "SentNoticeOfGeneralMeeting",
  SharepointSyncEvent = "SharepointSyncEvent",
  SignedBoardMinutes = "SignedBoardMinutes",
  SignedDocumentSealed = "SignedDocumentSealed",
  SignedGeneralMeeting = "SignedGeneralMeeting",
  SignedSubscriptionForm = "SignedSubscriptionForm",
  SubmittedDecisionToBR = "SubmittedDecisionToBR",
  SubmittedShareholderRegisterStatement = "SubmittedShareholderRegisterStatement",
  SubscribedWithNewInvoice = "SubscribedWithNewInvoice",
  UpdatedDecision = "UpdatedDecision",
  UpdatedEmail = "UpdatedEmail",
  UpdatedProject = "UpdatedProject",
  UsedAIAssistant = "UsedAIAssistant",
  VerifiedUserEmail = "VerifiedUserEmail",
}
